module.exports = __webpack_public_path__ + "video.cd7c821d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatsuite/video.png
// module id = 2078
// module chunks = 0